var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIsFavoriteSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.045 1.148c.29-.94 1.62-.94 1.91 0l.716 2.315a1 1 0 00.955.705h2.418c.956 0 1.367 1.214.607 1.795L10.61 7.522a1 1 0 00-.348 1.09l.759 2.456c.287.93-.79 1.68-1.563 1.09l-1.85-1.415a1 1 0 00-1.215 0l-1.851 1.414c-.774.591-1.85-.16-1.563-1.09l.76-2.455a1 1 0 00-.349-1.09l-2.04-1.56c-.76-.58-.35-1.794.606-1.794h2.418a1 1 0 00.955-.705l.716-2.315z",
    fill: "#1B5AF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.045 1.148c.29-.94 1.62-.94 1.91 0l.716 2.315a1 1 0 00.955.705h2.418c.956 0 1.367 1.214.607 1.795L10.61 7.522a1 1 0 00-.348 1.09l.759 2.456c.287.93-.79 1.68-1.563 1.09l-1.85-1.415a1 1 0 00-1.215 0l-1.851 1.414c-.774.591-1.85-.16-1.563-1.09l.76-2.455a1 1 0 00-.349-1.09l-2.04-1.56c-.76-.58-.35-1.794.606-1.794h2.418a1 1 0 00.955-.705l.716-2.315z",
    fill: "#fff",
    fillOpacity: 0.08
  })));
}
export default SvgIsFavoriteSelected;